import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ZpDataService } from "./../../services/zp-data.service";
import { UserInfoService } from "./../../services/user-info.service";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { CustomValidators } from "../../custom-validators";
import { FooterInfoService } from "src/app/services/footer-info.service";
import { GetInfoAndPassService } from "src/app/services/get-info-and-pass.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-sign-up-password",
    templateUrl: "./sign-up-password.component.html",
    styleUrls: ["./sign-up-password.component.scss"],
    standalone: false
})
export class SignUpPasswordComponent implements OnInit {
  public browserRefresh: boolean;
  public capsOn;
  public singUpForm: UntypedFormGroup;
  public submitted = false;
  public hide = true;
  public typeTerms: string;
  public statusPassword;
  public userType;
  public accessRight: any;
  public showTermsOfService: boolean;
  public closeRequirements: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private ZpDataService: ZpDataService,
    private router: Router,
    private userInfo: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private footerInfo: FooterInfoService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService
  ) {
    this.getInfoAndPassService.accessRightSection.subscribe((data) => {
      this.accessRight = data;
    });
  }

  ngOnInit() {
    this.sideNavBarVisibilityService.hideSideNav = true;
    if (
      this.ZpDataService.getRefCode() &&
      this.ZpDataService.getRefCodeInfo()
    ) {
      switch (this.ZpDataService.getRefCodeInfo().userType) {
        case "professionalManager":
          this.showTermsOfService = true;
          break;
        case "professional":
          this.showTermsOfService = true;
          break;
      }
    }
    this.singUpForm = this.formBuilder.group({
      email: ["", [Validators.email, Validators.required]],
      password: [
        "",
        Validators.compose([
          Validators.required,
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true,
          }),
          CustomValidators.patternValidator(/[!@#$%^&*(),.?":{}|<>]/, {
            hasSpecialSymbol: true,
          }),
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true,
          }),
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true,
          }),
          Validators.minLength(10),
        ]),
      ],
      acceptTerms: [false, Validators.requiredTrue],
      acceptPolicy: [false, Validators.requiredTrue],
      activated: [false],
      Id: [""],
      clientId: [""], //http://zp-dev.pivotalapps.com/sign-up-completed/3fb8056d-b8b8-4e6c-8f38-e9a7560680a3
      lastUpdate: [new Date()],
      lastName: [""],
      firstName: [""],
      dateOfBirth: [""],
      postCode: [""],
      hearAboutUs: [""],
      offersAuthorization: [""],
    });
  }

  get f() {
    return this.singUpForm.controls;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.singUpForm.invalid) {
      return;
    }
    this.singUpForm.controls["lastUpdate"].setValue(new Date());
    let pp = this.singUpForm.value;
    let myUser;

    if (
      this.ZpDataService.getRefCode() &&
      this.ZpDataService.getRefCodeInfo()
    ) {
      switch (this.ZpDataService.getRefCodeInfo().userType) {
        case "professionalManager":
          pp.userType = "professionalManager";
          let refCodeObj = await this.ZpDataService.createNewRefCode(
            undefined,
            "professional",
            undefined,
            true
          );
          pp.license = { refCode: refCodeObj.code };
          myUser = await this.ZpDataService.addUser(pp);
          this.footerInfo.isProfressional = true;
          if (myUser) {
            this.userInfo.changeMessage(JSON.stringify(myUser));
            //this.ZpDataService.setRefCode(refCodeObject.code);
            this.router.navigateByUrl(
              "/dynamicedit/professional-about-me-edit/" + myUser.Id
            );
          } else {
            alert("User creation failed.");
          }
          break;
        case "professional":
          pp.userType = "professional";
          let refCodeObject = await this.ZpDataService.createNewRefCode(
            undefined,
            "planHolder",
            undefined,
            true
          );
          pp.license = { refCode: refCodeObject.code };
          myUser = await this.ZpDataService.addUser(pp);
          this.footerInfo.isProfressional = true;
          if (myUser) {
            this.userInfo.changeMessage(JSON.stringify(myUser));
            if (this.ZpDataService.getRefCodeInfo().funded) {
              this.router.navigateByUrl(
                "/dynamicedit/professional-funded-about-me-edit/" + myUser.Id
              );
            } else {
              //this.ZpDataService.setRefCode(refCodeObject.code);
              this.router.navigateByUrl(
                "/dynamicedit/professional-about-me-edit/" + myUser.Id
              );
            }
          } else {
            alert("User creation failed.");
          }
          break;
        case "planHolder":
          pp.userType = "planHolder";
          myUser = await this.ZpDataService.addUser(pp);
          this.footerInfo.isProfressional = true;
          if (myUser) {
            this.userInfo.changeMessage(JSON.stringify(myUser));
            if (
              this.ZpDataService.getRefCodeInfo() &&
              this.ZpDataService.getRefCodeInfo().funded
            ) {
              this.router.navigateByUrl("/sponsor-page");
            } else {
              this.router.navigateByUrl(
                "/dynamicedit/about-me-edit/" + myUser.Id
              );
            }
          } else {
            alert("User creation failed.");
          }
      }
    } else {
      let pp = JSON.stringify(this.singUpForm.value);
      let myUser = await this.ZpDataService.addUser(pp);
      this.footerInfo.isProfressional = false;
      this.userInfo.changeMessage(JSON.stringify(myUser));
      this.router.navigateByUrl("/dynamicedit/about-me-edit-no-refcode/" + myUser.Id);
    }
    //this.router.navigateByUrl('/sign-up-completed/');
  }

  goto(url: string) {
    this.submitted = false;
    this.router.navigate(["/sign-up-completed" + url]);
  }

  onReset() {
    this.submitted = false;
    this.singUpForm.reset();
  }

  get passwordInput() {
    return this.singUpForm.get("password");
  }
}
